import {Component, Input, OnInit} from '@angular/core';
import {UIChart} from 'primeng/chart';

@Component({
    selector: 'app-doughnut-finance-chart',
    templateUrl: './doughnut-finance-chart.component.html',
    styleUrls: ['./doughnut-finance-chart.component.scss']
})
export class DoughnutFinanceChartComponent implements OnInit {
    @Input() donutData: {
        labels: string[],
        datasets: [{
            data: number[]
        }]
    };
    @Input() allTotal: number;
    @Input() showDonut: boolean;
    @Input() options: any;

    deviceWidth: number;
    hideDonutData: any = {
        0: false,
        1: false,
        2: false,
        3: false,
    };

    constructor() {
    }

    ngOnInit(): void {
        this.deviceWidth = Number(window.innerWidth);
    }

    updateDonut(donut: UIChart): void {
        setTimeout(() => {
            this.hideDonutData = donut.chart._hiddenIndices;
        });
    }

    getProjectTotal(): number {
        let total = this.allTotal;
        for (let i = 0; i <= 3; i++) {
            if (!this.hideDonutData[i]) {
                total += (this.donutData.datasets[0].data[i] * (i >= 2 ? -1 : 1));
            }
        }
        return total;
    }

    hideChart(donut: UIChart, index: any): void {
        donut.chart.toggleDataVisibility(index);
        donut.chart.update();
        this.updateDonut(donut);
    }
}
